import { parseApprovedImageHosts } from './classifyImageSource';

export const APPROVED_IMAGE_HOSTS: readonly string[] = parseApprovedImageHosts(import.meta.env.VITE_APPROVED_IMAGE_HOSTS);
